import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      padding: constants.divPadding,
      paddingBottom: spacing.xxs,
      borderRadius: constants.radius.view,
      backgroundColor: theme.card.background,
    },
    title: {
      fontWeight: "bold",
    },
    left: {
      flexGrow: 1,
    },
    seeMore: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
    },
  };

  return styles;
};
